$bog_smalljs_app $bog_builderui_div
	section? \home
	search_open? false
	search_toggle? null
	lights \light
	attr *
		^
		dir <= dir \ltr
	auto /
		<= hotkeys null
		<= lang_sync null
		<= route_canonical null
	sub /
		<= Top $bog_smalljs_top
			search_click? <=> search_toggle?
			Theme <= Theme $bog_theme_auto
				theme_light \$mol_theme_calm_light
				theme_dark \$mol_theme_calm_dark
				themes /
					\$mol_theme_calm_light
					\$mol_theme_calm_dark
		<= Body $mol_view
			dom_name \main
			sub <= body_content /
		<= Search $bog_smalljs_search
			open? <=> search_open?
			anchor_key <= docs_anchor_key \
	plugins /
		<= Skin $bog_builderui_skin
			lights <= lights
			base \zinc
			chart \yellow
			font_head \eb-garamond
		<= Theme
	Landing $bog_smalljs_landing
	Docs $bog_smalljs_docs
	Playground $bog_smalljs_playground
	Course $bog_smalljs_course
	Versus $bog_smalljs_versus
	Pair $bog_smalljs_versus_pair
		left <= versus_a \
		right <= versus_b \
		lights <= lights
